import React from "react";
import "./style.scss";
import { useTheme } from "styled-components";
export default function Footer({ children }) {
  const theme = useTheme();
  return (
    <div className="footer" style={{ ...theme.footer }}>
      {children}
    </div>
  );
}
